// removed by extract-text-webpack-plugin
module.exports = {"container":"FavNotificationsEmpty-style__container__a645cfd5","icon":"FavNotificationsEmpty-style__icon__a645cfd5","favoritesHeader":"FavNotificationsEmpty-style__favoritesHeader__a645cfd5","followHeader":"FavNotificationsEmpty-style__followHeader__a645cfd5","text":"FavNotificationsEmpty-style__text__a645cfd5","line":"FavNotificationsEmpty-style__line__a645cfd5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FavNotifications/FavNotificationsEmpty-style.scss
// module id = ./src/components/FavNotifications/FavNotificationsEmpty-style.scss
// module chunks = 4